export const getPortalAttributes = navPersona => {
  return navPersona.navPersonaPortalAttributes.reduce((acc, portalAttribute) => {
    acc[portalAttribute.personaAttributeKey.personaAttributeName] = portalAttribute.personaAttributeValue;
    return acc;
  }, {});
};
export const getPortalUserAttributes = navPersona => {
  return navPersona.navPersonaPortalUserAttributes.reduce((acc, portalAttribute) => {
    acc[portalAttribute.personaAttributeKey.personaAttributeName] = portalAttribute.personaAttributeValue;
    return acc;
  }, {});
};